// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Reading progress bar ────────────────────────────── */

.blog-post-page__progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--reading-progress, 0%);
  height: 3px;
  background: var(--color-accent-base);
  z-index: 1000;
  transition: width 0.1s linear;
  pointer-events: none;
}

/* ── Page container ──────────────────────────────────── */

.blog-post-page {
  max-width: 820px;
  margin: 0 auto;
  padding: 28px 24px 96px;
  color: var(--color-text-primary);
}

/* ── Breadcrumb navigation ───────────────────────────── */

.blog-post-page__breadcrumb {
  margin-bottom: 24px;
}

.blog-post-page__breadcrumb ol {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.82rem;
  color: var(--color-text-secondary);
}

.blog-post-page__breadcrumb li {
  display: flex;
  align-items: center;
}

.blog-post-page__breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: var(--color-text-secondary);
  opacity: 0.5;
}

.blog-post-page__breadcrumb li:last-child {
  color: var(--color-text-secondary);
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 360px;
}

.blog-post-page__breadcrumb a {
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.blog-post-page__breadcrumb a:hover {
  color: var(--color-accent-base);
}

/* ── Article card ────────────────────────────────────── */

.blog-post-page__article {
  border: 1px solid var(--color-border-input);
  border-radius: 18px;
  background: var(--color-bg-canvas-surface);
  padding: 36px 40px;
  box-shadow: var(--color-shadow-canvas-frame);
}

/* ── Header ──────────────────────────────────────────── */

.blog-post-page__header {
  border-bottom: 1px solid var(--color-border-input);
  margin-bottom: 28px;
  padding-bottom: 24px;
}

.blog-post-page__meta-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 0.84rem;
  color: var(--color-text-secondary);
}

.blog-post-page__title {
  margin: 0;
  font-size: clamp(2rem, 3.8vw, 2.9rem);
  line-height: 1.12;
  letter-spacing: -0.01em;
  font-weight: 400;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.blog-post-page__description {
  margin: 16px 0 0;
  line-height: 1.65;
  font-size: 1.05rem;
  color: var(--color-text-secondary);
}

/* ── Tags ────────────────────────────────────────────── */

.blog-post-page__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 18px;
}

.blog-post-page__tag {
  border: 1px solid var(--color-border-input);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 0.74rem;
  font-weight: 500;
  color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
  transition: border-color 0.2s ease;
}

.blog-post-page__tag:hover {
  border-color: var(--color-accent-base);
}

/* ── Loading skeleton ────────────────────────────────── */

.blog-post-page__status {
  padding: 24px 0;
}

.blog-post-page__skeleton {
  height: 16px;
  border-radius: 8px;
  background: var(--color-bg-canvas-frame);
  margin-bottom: 14px;
  animation: skeleton-pulse 1.4s ease-in-out infinite;
}

.blog-post-page__skeleton--short {
  width: 65%;
}

@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.blog-post-page__status--error {
  color: var(--color-status-error-text);
}

/* ── Cover image ─────────────────────────────────────── */

.blog-post-page__cover {
  display: block;
  width: calc(100% + 80px);
  margin-left: -40px;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-top: 1px solid var(--color-border-input);
  border-bottom: 1px solid var(--color-border-input);
  margin-bottom: 32px;
  background: var(--color-bg-canvas-frame);
}

/* ── Article content ─────────────────────────────────── */

.blog-post-page__content {
  line-height: 1.75;
  font-size: 1.02rem;
  color: var(--color-text-primary);
}

.blog-post-page__content h1,
.blog-post-page__content h2,
.blog-post-page__content h3,
.blog-post-page__content h4 {
  margin: 2.2rem 0 0.75rem;
  line-height: 1.25;
  letter-spacing: -0.005em;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
}

.blog-post-page__content h1 {
  margin-top: 0;
  font-size: 1.85rem;
}

.blog-post-page__content h2 {
  font-size: 1.5rem;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-border-input);
}

.blog-post-page__content h3 {
  font-size: 1.2rem;
}

.blog-post-page__content p,
.blog-post-page__content ul,
.blog-post-page__content ol,
.blog-post-page__content pre,
.blog-post-page__content blockquote {
  margin: 0 0 1.15rem;
}

.blog-post-page__content ul,
.blog-post-page__content ol {
  padding-left: 1.4rem;
}

.blog-post-page__content li {
  margin-bottom: 0.3rem;
}

.blog-post-page__content blockquote {
  border-left: 3px solid var(--color-accent-base);
  margin-left: 0;
  padding: 0.6rem 0 0.6rem 1.2rem;
  color: var(--color-text-secondary);
  font-style: italic;
  background: var(--color-bg-user-bubble);
  border-radius: 0 8px 8px 0;
}

.blog-post-page__content code {
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.88em;
  background: var(--color-bg-user-bubble);
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  padding: 0.1rem 0.35rem;
}

.blog-post-page__content pre {
  overflow-x: auto;
  background: var(--color-bg-canvas-frame);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  padding: 1rem 1.1rem;
}

.blog-post-page__content pre code {
  background: transparent;
  border: none;
  color: inherit;
  padding: 0;
  font-size: 0.84rem;
  line-height: 1.6;
}

.blog-post-page__content a {
  color: var(--color-accent-base);
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: rgba(192, 123, 66, 0.35);
  transition: text-decoration-color 0.15s ease;
}

.blog-post-page__content a:hover {
  text-decoration-color: var(--color-accent-base);
}

.blog-post-page__content img {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  border: 1px solid var(--color-border-input);
}

.blog-post-page__content hr {
  border: none;
  border-top: 1px solid var(--color-border-input);
  margin: 2rem 0;
}

.blog-post-page__content table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.15rem;
  font-size: 0.92rem;
}

.blog-post-page__content th,
.blog-post-page__content td {
  border: 1px solid var(--color-border-input);
  padding: 10px 14px;
  text-align: left;
}

.blog-post-page__content th {
  background: var(--color-bg-user-bubble);
  font-weight: 600;
}

/* ── Legacy classes ──────────────────────────────────── */

.blog-post-page__loading,
.blog-post__render-error {
  color: var(--color-text-secondary);
}

/* ── Responsive ──────────────────────────────────────── */

@media (max-width: 900px) {
  .blog-post-page {
    padding: 24px 16px 72px;
  }

  .blog-post-page__article {
    padding: 24px;
    border-radius: 14px;
  }

  .blog-post-page__cover {
    width: calc(100% + 48px);
    margin-left: -24px;
  }
}

@media (max-width: 600px) {
  .blog-post-page__article {
    padding: 18px;
  }

  .blog-post-page__cover {
    width: calc(100% + 36px);
    margin-left: -18px;
  }

  .blog-post-page__breadcrumb li:last-child {
    max-width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/BlogPostPage.css"],"names":[],"mappings":"AAEA,2DAA2D;;AAE3D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,2DAA2D;;AAE3D;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,2DAA2D;;AAE3D;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,2DAA2D;;AAE3D;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,2DAA2D;;AAE3D;EACE,kDAAkD;EAClD,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,2DAA2D;;AAE3D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,2DAA2D;;AAE3D;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2DAA2D;;AAE3D;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,+CAA+C;EAC/C,kDAAkD;EAClD,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,2DAA2D;;AAE3D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;;;EAIE,wBAAwB;EACxB,iBAAiB;EACjB,wBAAwB;EACxB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;EAC5E,iBAAiB;EACjB,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,+CAA+C;EAC/C,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,2DAA2D;;AAE3D;;EAEE,kCAAkC;AACpC;;AAEA,2DAA2D;;AAE3D;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n/* ── Reading progress bar ────────────────────────────── */\n\n.blog-post-page__progress-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: var(--reading-progress, 0%);\n  height: 3px;\n  background: var(--color-accent-base);\n  z-index: 1000;\n  transition: width 0.1s linear;\n  pointer-events: none;\n}\n\n/* ── Page container ──────────────────────────────────── */\n\n.blog-post-page {\n  max-width: 820px;\n  margin: 0 auto;\n  padding: 28px 24px 96px;\n  color: var(--color-text-primary);\n}\n\n/* ── Breadcrumb navigation ───────────────────────────── */\n\n.blog-post-page__breadcrumb {\n  margin-bottom: 24px;\n}\n\n.blog-post-page__breadcrumb ol {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.82rem;\n  color: var(--color-text-secondary);\n}\n\n.blog-post-page__breadcrumb li {\n  display: flex;\n  align-items: center;\n}\n\n.blog-post-page__breadcrumb li:not(:last-child)::after {\n  content: \"/\";\n  margin: 0 8px;\n  color: var(--color-text-secondary);\n  opacity: 0.5;\n}\n\n.blog-post-page__breadcrumb li:last-child {\n  color: var(--color-text-secondary);\n  opacity: 0.8;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 360px;\n}\n\n.blog-post-page__breadcrumb a {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.blog-post-page__breadcrumb a:hover {\n  color: var(--color-accent-base);\n}\n\n/* ── Article card ────────────────────────────────────── */\n\n.blog-post-page__article {\n  border: 1px solid var(--color-border-input);\n  border-radius: 18px;\n  background: var(--color-bg-canvas-surface);\n  padding: 36px 40px;\n  box-shadow: var(--color-shadow-canvas-frame);\n}\n\n/* ── Header ──────────────────────────────────────────── */\n\n.blog-post-page__header {\n  border-bottom: 1px solid var(--color-border-input);\n  margin-bottom: 28px;\n  padding-bottom: 24px;\n}\n\n.blog-post-page__meta-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n  font-size: 0.84rem;\n  color: var(--color-text-secondary);\n}\n\n.blog-post-page__title {\n  margin: 0;\n  font-size: clamp(2rem, 3.8vw, 2.9rem);\n  line-height: 1.12;\n  letter-spacing: -0.01em;\n  font-weight: 400;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.blog-post-page__description {\n  margin: 16px 0 0;\n  line-height: 1.65;\n  font-size: 1.05rem;\n  color: var(--color-text-secondary);\n}\n\n/* ── Tags ────────────────────────────────────────────── */\n\n.blog-post-page__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 18px;\n}\n\n.blog-post-page__tag {\n  border: 1px solid var(--color-border-input);\n  border-radius: 999px;\n  padding: 4px 12px;\n  font-size: 0.74rem;\n  font-weight: 500;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n  transition: border-color 0.2s ease;\n}\n\n.blog-post-page__tag:hover {\n  border-color: var(--color-accent-base);\n}\n\n/* ── Loading skeleton ────────────────────────────────── */\n\n.blog-post-page__status {\n  padding: 24px 0;\n}\n\n.blog-post-page__skeleton {\n  height: 16px;\n  border-radius: 8px;\n  background: var(--color-bg-canvas-frame);\n  margin-bottom: 14px;\n  animation: skeleton-pulse 1.4s ease-in-out infinite;\n}\n\n.blog-post-page__skeleton--short {\n  width: 65%;\n}\n\n@keyframes skeleton-pulse {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n.blog-post-page__status--error {\n  color: var(--color-status-error-text);\n}\n\n/* ── Cover image ─────────────────────────────────────── */\n\n.blog-post-page__cover {\n  display: block;\n  width: calc(100% + 80px);\n  margin-left: -40px;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  border-top: 1px solid var(--color-border-input);\n  border-bottom: 1px solid var(--color-border-input);\n  margin-bottom: 32px;\n  background: var(--color-bg-canvas-frame);\n}\n\n/* ── Article content ─────────────────────────────────── */\n\n.blog-post-page__content {\n  line-height: 1.75;\n  font-size: 1.02rem;\n  color: var(--color-text-primary);\n}\n\n.blog-post-page__content h1,\n.blog-post-page__content h2,\n.blog-post-page__content h3,\n.blog-post-page__content h4 {\n  margin: 2.2rem 0 0.75rem;\n  line-height: 1.25;\n  letter-spacing: -0.005em;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n}\n\n.blog-post-page__content h1 {\n  margin-top: 0;\n  font-size: 1.85rem;\n}\n\n.blog-post-page__content h2 {\n  font-size: 1.5rem;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.blog-post-page__content h3 {\n  font-size: 1.2rem;\n}\n\n.blog-post-page__content p,\n.blog-post-page__content ul,\n.blog-post-page__content ol,\n.blog-post-page__content pre,\n.blog-post-page__content blockquote {\n  margin: 0 0 1.15rem;\n}\n\n.blog-post-page__content ul,\n.blog-post-page__content ol {\n  padding-left: 1.4rem;\n}\n\n.blog-post-page__content li {\n  margin-bottom: 0.3rem;\n}\n\n.blog-post-page__content blockquote {\n  border-left: 3px solid var(--color-accent-base);\n  margin-left: 0;\n  padding: 0.6rem 0 0.6rem 1.2rem;\n  color: var(--color-text-secondary);\n  font-style: italic;\n  background: var(--color-bg-user-bubble);\n  border-radius: 0 8px 8px 0;\n}\n\n.blog-post-page__content code {\n  font-family: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.88em;\n  background: var(--color-bg-user-bubble);\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  padding: 0.1rem 0.35rem;\n}\n\n.blog-post-page__content pre {\n  overflow-x: auto;\n  background: var(--color-bg-canvas-frame);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  padding: 1rem 1.1rem;\n}\n\n.blog-post-page__content pre code {\n  background: transparent;\n  border: none;\n  color: inherit;\n  padding: 0;\n  font-size: 0.84rem;\n  line-height: 1.6;\n}\n\n.blog-post-page__content a {\n  color: var(--color-accent-base);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-color: rgba(192, 123, 66, 0.35);\n  transition: text-decoration-color 0.15s ease;\n}\n\n.blog-post-page__content a:hover {\n  text-decoration-color: var(--color-accent-base);\n}\n\n.blog-post-page__content img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 10px;\n  border: 1px solid var(--color-border-input);\n}\n\n.blog-post-page__content hr {\n  border: none;\n  border-top: 1px solid var(--color-border-input);\n  margin: 2rem 0;\n}\n\n.blog-post-page__content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1.15rem;\n  font-size: 0.92rem;\n}\n\n.blog-post-page__content th,\n.blog-post-page__content td {\n  border: 1px solid var(--color-border-input);\n  padding: 10px 14px;\n  text-align: left;\n}\n\n.blog-post-page__content th {\n  background: var(--color-bg-user-bubble);\n  font-weight: 600;\n}\n\n/* ── Legacy classes ──────────────────────────────────── */\n\n.blog-post-page__loading,\n.blog-post__render-error {\n  color: var(--color-text-secondary);\n}\n\n/* ── Responsive ──────────────────────────────────────── */\n\n@media (max-width: 900px) {\n  .blog-post-page {\n    padding: 24px 16px 72px;\n  }\n\n  .blog-post-page__article {\n    padding: 24px;\n    border-radius: 14px;\n  }\n\n  .blog-post-page__cover {\n    width: calc(100% + 48px);\n    margin-left: -24px;\n  }\n}\n\n@media (max-width: 600px) {\n  .blog-post-page__article {\n    padding: 18px;\n  }\n\n  .blog-post-page__cover {\n    width: calc(100% + 36px);\n    margin-left: -18px;\n  }\n\n  .blog-post-page__breadcrumb li:last-child {\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
